// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"31":"dbcbbb27","96":"6d979dc4","233":"140f99ab","453":"ce451b92","469":"42221a59","979":"92052df4","997":"bdb4316c"}[chunkId] + ".chunk.js";
};